import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ServiceBase } from '../shared/servicebase'
import { Helper } from '../shared/Helper';

@Injectable({
  providedIn: 'root'
})
export class LoginService extends ServiceBase {

  public Usuario: string;
  public codTabela: string;
  constructor(http: HttpClient) {
    super(http);

  }

  public Refresh()
  {
    var that = this;
    setTimeout(function () { that.Usuario = Helper.getNomeToken(); that.codTabela = Helper.getCodTab() }, 2000);    
  }

  public Logado: boolean;

  public Logar(usuario: string, senha: string, cpfCnpj?: string): Observable<any> {
    let credentials = {
      UserName: usuario,
      Password: senha,
      CpfCnpj: cpfCnpj
    }
    return this.SetValue('auth/login', credentials);
  }

  public SolicitarChave(codigo: string, cpfCnpj?: string): Observable<any> {
    let credentials = {
      codigo: codigo,
      cpfCnpj: cpfCnpj
    }
    return this.SetValue('auth/solicitar', credentials);
  }
  public Cadastrar(login: string, chave: string, senha: string, cpfCnpj?: string): Observable<any> {
    let credentials = {
      login: login,
      chave: chave,
      senha: senha,
      cpfCnpj: cpfCnpj
    }
    return this.SetValue('auth/cadastrar', credentials);
  }

  public EsqueciSenha(login: string): Observable<any> {    
    return this.GetValue('auth/esquecisenha/'+login);
  }
  public LocalizarLogin(login: string): Observable<any> {    
    return this.GetValue('auth/localizarlogin/'+login);
  }

  AlterarSenha(senhaAtual, novaSenha): Observable<any> {
    return this.GetValue<any>('user/usuario/alterarsenha/' + Helper.getUserIdToken() + '/' + senhaAtual + '/' + novaSenha);
  }

}
